import template from "./about.html";
import controller from "./about.controller";

const aboutComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller,
};

export default aboutComponent;
